import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useDispatchApp } from 'Hooks';
import { useIsLawyerArea } from 'Hooks/useIsLawyerArea';
import { setFakeUser, setImposterId, setIsLawyerArea } from 'Store';
import { useNavigate } from 'react-router-dom';

export const CustomToggleButtons = () => {
  const isLawyerArea = useIsLawyerArea();
  const dispatch = useDispatchApp();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Lawyers);
  const navigate = useNavigate();

  const handleChange = (event: React.MouseEvent<HTMLElement>, value: boolean | null) => {
    if (value !== null) {
      dispatch(setIsLawyerArea(value));
      sessionStorage.setItem('isLawyerArea', value.toString());
      navigate(value ? '/lawyers-lobby' : '/');
      if (!value) {
        dispatch(setImposterId(''));
        dispatch(setFakeUser({}));
      }
    }
  };

  return (
    <ToggleButtonGroup
      value={isLawyerArea}
      exclusive
      onChange={handleChange}
      aria-label={dictionary.switchBetweenLawyersAndUsers}
      sx={{
        alignSelf: 'center',
        bgcolor: 'white',
        borderRadius: '47px',
        border: 0,
        height: '47px !important',
        justifyContent: 'space-between',
        p: '4px',
        gap: '6px',
        boxShadow: '0px -1px 10px 0px #00000012',
      }}
    >
      <ToggleButton
        sx={{
          p: '8px 0px',
          bgcolor: isLawyerArea === false ? '#A020FF !important' : 'white',
          color: isLawyerArea === false ? 'white !important' : 'black !important',
          width: '117px',
          border: 0,
          ':hover': { bgcolor: '#A020FF', color: 'white !important' },
          borderRadius: '40px !important',
        }}
        value={false}
      >
        <Typography
          sx={{
            fontSize: '16px !important',
            lineHeight: '24px !important',
            fontWeight: isLawyerArea === false ? '700' : '400 !important',
            minWidth: 'max-content',
          }}
        >
          {dictionary.personalArea}
        </Typography>
      </ToggleButton>
      <ToggleButton
        sx={{
          p: '8px 0px',
          bgcolor: isLawyerArea !== false ? '#A020FF !important' : 'white',
          color: isLawyerArea !== false ? 'white !important' : 'black !important',
          width: '117px',
          border: 0,
          ':hover': { bgcolor: '#A020FF', color: 'white !important' },
          borderRadius: '40px !important',
          ml: '0px !important',
          mr: '-1px',
        }}
        value={true}
      >
        <Typography
          sx={{
            fontSize: '16px !important',
            lineHeight: '24px !important',
            fontWeight: isLawyerArea ? '700' : '400 !important',
            minWidth: 'max-content',
            mr: '2px',
          }}
        >
          {dictionary.repArea}
        </Typography>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
